import {
  Conversation,
  ConversationTask,
} from '@terminal/views/alfred/research/use-chat/use-chat.types';

const ERRORED_TASK_STATUSES = ['Error', 'Fatal', 'Cancel'];

export interface NewlyCompletedResponse {
  conversationId: string;
  requestId: string;
  type?: string;
}

const isResearchTaskComplete = (task: ConversationTask): boolean =>
  !!task.states?.length && !task.states.at(-1)?.next;

const isResearchTaskErrored = (task: ConversationTask): boolean =>
  ERRORED_TASK_STATUSES.includes(task.states?.at(-1)?.status ?? '');

const collectTasksByRequestId = (
  conversations: Conversation[]
): Map<string, ConversationTask> => {
  const tasksByRequestId = new Map<string, ConversationTask>();

  conversations.forEach(conversation => {
    conversation.tasks?.forEach(task => {
      tasksByRequestId.set(task.request_id, task);
    });
  });

  return tasksByRequestId;
};

export const getNewlyCompletedResponses = (
  conversations: Conversation[],
  previousConversations: Conversation[]
): NewlyCompletedResponse[] => {
  const previousTasksByRequestId = collectTasksByRequestId(
    previousConversations
  );
  const newlyCompleted: NewlyCompletedResponse[] = [];

  conversations.forEach(conversation => {
    conversation.tasks?.forEach(task => {
      const previousTask = previousTasksByRequestId.get(task.request_id);

      if (
        previousTask &&
        !isResearchTaskComplete(previousTask) &&
        isResearchTaskComplete(task) &&
        !isResearchTaskErrored(task)
      ) {
        newlyCompleted.push({
          conversationId: conversation.id,
          requestId: task.request_id,
          type: task.submittedAnalysisMode ?? task.analysis_mode ?? undefined,
        });
      }
    });
  });

  return newlyCompleted;
};
